"use client";

import { useEffect, useState } from "react";

const programs = [
  {
    title: "IIT JAM Chemistry",
    description:
      "Complete preparation for IIT Joint Admission Test with advanced problem-solving techniques.",
    duration: "12 Months",
    icon: "🧪",
    text: "Enroll Now",
  },
  {
    title: "GATE Chemistry",
    description:
      "Comprehensive GATE coaching covering theoretical and numerical problem-solving strategies.",
    duration: "12 Months",
    icon: "⚗️",
    text: "Coming Soon",
  },
  {
    title: "NET Chemistry",
    description:
      "Specialized NET preparation with focus on research aptitude and conceptual clarity.",
    duration: "12 Months",
    icon: "🔬",
    text: "Coming Soon",
  },
  {
    title: "IIT JEE",
    description:
      "Advanced coaching for IIT JEE aspirants with a focus on conceptual clarity and problem-solving speed.",
    duration: "12 Months",
    icon: "📘",
    text: "Coming Soon",
  },
  {
    title: "NEET",
    description:
      "Comprehensive NEET preparation with detailed theory, tests, and personalized guidance.",
    duration: "12 Months",
    icon: "🩺",
    text: "Coming Soon",
  },
];

export default function Programs() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="programs" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#162456]">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div
          className={`text-center mb-16 ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-pretty text-white">
            Our <span className="text-[var(--secondary-color)]">Programs</span>
          </h2>
          <p className="text-lg text-white max-w-2xl mx-auto">
            Choose the program that fits your goals. All programs include live
            classes, doubt sessions, and comprehensive study materials.
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid md:grid-cols-3  gap-8 relative">
          {/* Decorative background circles */}
          <div className="absolute -top-40 -left-40 w-80 h-80 bg-blue-800/20 rounded-full blur-3xl pointer-events-none"></div>
          <div className="absolute -bottom-40 -right-40 w-80 h-80 bg-blue-800/20 rounded-full blur-3xl pointer-events-none"></div>

          {programs.map((program, index) => (
            <div
              key={index}
              className={`group relative bg-white rounded-xl border-2 border-blue-200 shadow-lg hover:shadow-2xl hover:-translate-y-3 transition-all duration-300 p-8 ${
                isVisible ? "animate-fade-in-up" : "opacity-0"
              } overflow-hidden`}
              style={{ animationDelay: isVisible ? `${index * 0.15}s` : "0s" }}
            >
              {/* Hover gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-300/0 to-blue-400/0 group-hover:from-yellow-300/10 group-hover:to-blue-400/20 transition-all duration-300 pointer-events-none"></div>

              <div className="relative z-10">
                <div className="text-5xl mb-4 group-hover:scale-110 transition-transform duration-300">
                  {program.icon}
                </div>
                <h3 className="text-2xl font-bold mb-3 text-blue-950">
                  {program.title}
                </h3>
                <p className="text-[#193cb8] mb-6">{program.description}</p>

                <div className="flex items-center justify-between mb-6 pb-6 border-b-2 border-blue-200">
                  <div>
                    <p className="text-sm text-[#193cb8]">Duration</p>
                    <p className="text-lg font-semibold text-blue-950">
                      {program.duration}
                    </p>
                  </div>
                </div>

                <button className="w-full bg-[#193cb8] text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-800 hover:shadow-lg transition-all duration-300 group-hover:shadow-blue-600/50">
                  {program.text}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
